<template>
  <form class="h-100">
    <border-layout>
      <scrollable>
        <b-alert variant="warning" show class="m-0">
          <!-- TODO i18n -->
          Attenzione: ogni box in questa sezione rappresenta una serie di
          alternative. Per ogni serie di alternative sarà obbligatorio caricare
          almeno un file.
        </b-alert>
        <template v-for="(alternative, index) in value.tagAlternatives">
          <b-card :key="alternative.id">
            <tag-form-field
              :disabled="disabled"
              class="mb-0"
              :value="alternative.tags"
              :dropdown="false"
              multiple
              :error="findError('tagAlternatives[' + index + '].tags')"
              @input="onChange(index, $event)"
            ></tag-form-field>
            <div class="text-right" v-if="!disabled">
              <b-button variant="danger" @click.prevent="remove(index)">
                {{ $t("common.remove") }}
              </b-button>
            </div>
          </b-card>
        </template>
      </scrollable>
      <template slot="footer">
        <div class="text-right" v-if="!disabled">
          <b-button variant="add" @click.prevent="add">
            {{ $t("common.add") }}
          </b-button>
        </div>
      </template>
    </border-layout>
    <!--
    <template slot="title">
      <i class="fa fa-fw fa-tag"></i>
      <span v-if="isSmUp" class="ml-1">
        {{ $t('creditAssignmentFileStatus.tabs.tagAlternatives') }}
      </span>
    </template>
    -->
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";
import TagFormField from "@/modules/tag/protected/TagFormField";

export default {
  mixins: [EditorMixin, ErrorCounterMixin],

  components: {
    TagFormField
  },

  methods: {
    onChange(index, value) {
      const LIST_FIELD = "tagAlternatives";
      const newArr = [...this.value[LIST_FIELD]];
      const newRow = { ...newArr[index], tags: value };
      newArr[index] = newRow;
      this.propertyChange(LIST_FIELD, newArr);
      return false;
    },

    add() {
      const LIST_FIELD = "tagAlternatives";
      const newArr = [...this.value[LIST_FIELD], {}];
      this.propertyChange(LIST_FIELD, newArr);
    },

    remove(index) {
      if (!confirm(this.$t("common.confirm"))) {
        return;
      }
      const LIST_FIELD = "tagAlternatives";
      const newArr = [...this.value[LIST_FIELD]];
      newArr.splice(index, 1);
      this.propertyChange(LIST_FIELD, newArr);
      return false;
    }
  }
};
</script>
